import resetRequestStates from './resetRequestStates';
const LOG_TYPES = {
  MANUFACTURING: 'manufacturing',
  SHIPMENT: 'shipment'
};
const SKU_TYPES = {
  GATEWAY: 'gateway',
  TAG: 'tag'
};
const GATEWAY_SKUS = [{
  name: 'HW1872-1.0',
  value: 'HW1872-1.0'
}, {
  name: 'HW1868-2.0-RG',
  value: 'HW1868-2.0-RG'
}, {
  name: 'HW1868-2.1-RG',
  value: 'HW1868-2.1-RG'
}, {
  name: 'HW1872-2.0',
  value: 'HW1872-2.0'
}];
const TAG_SKUS = [{
  name: 'HW1895-1.0',
  value: 'HW1895-1.0'
}];
const LOCATION_TYPES = {
  DEALERSHIP: 'dealership',
  CONSUMER: 'consumer',
  MANUFACTURING: 'manufacturing'
};
const RECOVR_HOTLINE_NUMBER = '+1 888-306-7166';
const ONE_HOUR_IN_MS = 60 * 60 * 1000;
export default {
  resetRequestStates,
  LOG_TYPES,
  SKU_TYPES,
  GATEWAY_SKUS,
  TAG_SKUS,
  LOCATION_TYPES,
  RECOVR_HOTLINE_NUMBER,
  ONE_HOUR_IN_MS
};
export { LOG_TYPES, SKU_TYPES, GATEWAY_SKUS, TAG_SKUS, LOCATION_TYPES, RECOVR_HOTLINE_NUMBER, ONE_HOUR_IN_MS, resetRequestStates };